import {Enum} from 'enumify';

export default class DeviceType extends Enum {}

DeviceType.initEnum({
  SMART_GLOVE: {
    title: 'Smart Glove',
    isSidedDevice: true,
    isNeedDisplay: true,
  },
  SMART_KIDS: {
    title: 'Smart Kids',
    isSidedDevice: true,
    isNeedDisplay: true,
  },
  SMART_BOARD: {
    title: 'Smart Board',
    isSidedDevice: false,
    isNeedDisplay: true,
  },
  SMART_PEGBOARD: {
    title: 'Smart Pegboard',
    isSidedDevice: false,
    isNeedDisplay: false,
  },
  COMCOG: {
    title: 'ComCog',
    isSidedDevice: false,
    isNeedDisplay: true,
  },
  OT_SESSION: {
	    title: 'OT Session',
	    isSidedDevice: false,
	    isNeedDisplay: false,
	  }
});



// WEBPACK FOOTER //
// ./src/constants/DeviceType.js